import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faLink,
	faWindowClose,
	faExternalLinkAlt,
	faEyeSlash
} from "@fortawesome/free-solid-svg-icons";
import React, { Component } from "react";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";

export default class TableKey extends Component {
	static displayName = TableKey.name;

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<>
				<Accordion defaultActiveKey="0">
					<Card style={{ width: "18rem" }}>
						<Accordion.Toggle as={Card.Header} eventKey="0">
							Click for Table Key
						</Accordion.Toggle>
						<Accordion.Collapse eventKey="0">
							<Card.Body>
								<Card.Title>Important Notes</Card.Title>
								<div>
									<FontAwesomeIcon icon={faWindowClose} color="red" size="xs" />{" "} -
									 Do Not Stock - Order Per Job
								</div>
								<div>
									<FontAwesomeIcon icon={faLink} color="green" size="xs" />{" "} -
									 Special Connector
								</div>
								<div>
									<FontAwesomeIcon icon={faEyeSlash}  size="xs" />{" "} -
									 Not for video transmission
								</div>
								<br />
								<Card.Title>Link</Card.Title>
								<div>
									<FontAwesomeIcon
										icon={faExternalLinkAlt}
										color="blue"
										size="xs"
									/>{" "}
									URL Link
								</div>
							</Card.Body>
						</Accordion.Collapse>
					</Card>
				</Accordion>
			</>
		);
	}
}
